import { Attribute } from '@app/gen/events';

type TextAttribute = Attribute & { value: string };

export const isTextAttribute = (
  attribute: Attribute,
): attribute is TextAttribute =>
  attribute.type !== 'file' && attribute.type !== 'file_multiple';
